document.addEventListener('DOMContentLoaded', function() {
    var globeSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>';
    
    var boxes = document.querySelectorAll('.icon-box-item');
    if (boxes[2]) {
        var oldSVG = boxes[2].querySelector('svg');
        if (oldSVG) {
            oldSVG.outerHTML = globeSVG;
        }
    }
});
